import { render, staticRenderFns } from "./offlineTraining.vue?vue&type=template&id=6acf8670"
import script from "./offlineTraining.vue?vue&type=script&lang=js"
export * from "./offlineTraining.vue?vue&type=script&lang=js"
import style0 from "./offlineTraining.vue?vue&type=style&index=0&id=6acf8670&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports